import { Component } from '@angular/core';
import { PaymentPaymentOptionCardFormAbstractForm } from '../payment.payment.option.card.form.abstract-form';

@Component({
    'selector': 'payment-payment-option-card-form-bspag',
    'templateUrl': './payment.payment.option.card.form.bspag.component.html',
    'providers': [],
    'styleUrls': ['../../../../../../payment.component.scss']
})
export class PaymentPaymentOptionCardFormBspagComponent extends
    PaymentPaymentOptionCardFormAbstractForm {
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/payment/payment/option/card/option/form/bspag/payment.payment.option.card.form.bspag.component.ts